import React from "react";
import styles from "./Faq.module.scss";
import CardHeaderPage from "../UiComponents/card/CardHeaderPage";
import { RiInstallLine, RiPagesLine } from "react-icons/ri";
import { MdHeadphones } from "react-icons/md";
import { BsSpeakerFill } from "react-icons/bs";
import { FcSpeaker } from "react-icons/fc";
import insertSvg from "../../pics/insertSvg2.png";
import CategoriesFaq from "./CategoriesFaq";
import ContactFaq from "./ContactFaq";
import Questions from "./Questions";
import { QuestionData } from "./QuestionData";
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";

const Faq = () => {
  const videoList = [
    {
      url: "https://www.youtube.com/embed/CA-OXasI1CE",
      title: "Installation Hearing-Space",
    },
    {
      url: "https://www.youtube.com/embed/4sBqZDpN8Pk",
      title: "Calibration du champ libre",
    },
    {
      url: "https://www.youtube.com/embed/RQqMR2s5hos",
      title: "Calibration Casques",
    },
    {
      url: "https://www.youtube.com/embed/ZUtmdMd3VkI",
      title: "Calibration Inserts",
    },
    {
      url: "https://www.youtube.com/embed/QUdhPwiYjrI",
      title: "Installation du champ libre",
    },
    {
      url: "https://www.youtube.com/embed/PttdrPRYWik?si=r-_VH3Bbivk4QREt",
      title: "Test de localisation spatiale",
    },
  ];

  const downloadManual = () => {
    window.open("https://hearing-space.com/hs-manual", "_blank");
  };

  return (
    <motion.div
      className={styles.container}
      variants={animatePage}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
    
      <div className={styles.containerManual}>
  <div className={styles.manualCard} onClick={downloadManual}>
    <div className={styles.manualTitle}>Mode d'emploi Hearing Space</div>
    <div className={styles.manualButton}>
      <RiPagesLine />
      <span>Télécharger le mode d'emploi</span>
    </div>
  </div>
</div>


    
      <div className={styles.containerVideos}>
        {videoList.map((video, index) => (
          <div key={index} className={styles.videoCard}>
            <iframe
              src={video.url}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <div className={styles.title}>{video.title}</div>
          </div>
        ))}
      </div>

      <div className={styles.containerQuestions}>
    
        {QuestionData.map((ques, index) => (
          <Questions
            key={index}
            questions={ques.question}
            answer={ques.answer}
            link={ques.link}
            textLink={ques.linkText}
            list={ques.list}
          />
        ))}
      </div>

      <ContactFaq />
    </motion.div>
  );
};

export default Faq;
